<template>
  <div v-if="this.integrationStatus.loading" style="display: flex; justify-content: center; align-items: center; min-height: 80vh;">
    <i class="fas fa-spinner fa-spin" style="font-size: 40px;"></i>
  </div>
  <div v-else-if="this.integrationStatus.error">
    <ErrorPage />
  </div>
  <div v-else class="row">
    <div class="col-12">
      <div class="integration__header">
        <el-button
          class="btn-redirect-integration" 
          type="text"
          @click="$router.go(-1)"
          icon="el-icon-arrow-left" 
        >Back</el-button>
        <div class="d-flex flex-column">
          <h3 class="mb-1 emm__page-heading">Integrations</h3>
          <span class="emm__page-sub-heading">Supercharge your leads and connect with tools that you use
            everyday</span>
        </div>
      </div>
      <div class="row integration__filters-wrapper mt-5 d-flex justify-content-between align-items-start">
        <div class="col-sm-12 col-md-12 col-lg-7 integration-filters d-flex align-items-center justify-content-start" style="padding-block: 16px;">
          <div
            v-for="type in ['all', 'Communication', 'Mail']"
            :key="type"
            :class="['filter-item-integration', { active: selectedType === type }]"
            @click="selectedType = type"
          >
            {{ type.charAt(0).toUpperCase() + type.slice(1) }}
          </div>
          </div>
        <div class="col-sm-12 col-md-12 col-lg-5 emm__integration-serach-input-wrapper" style="padding-block: 16px;">
          <base-input>
            <el-input type="search" class="search-input mb-0 input__integrations" clearable prefix-icon="el-icon-search"
              placeholder="Search integration" v-model="searchQuery" aria-controls="datatables">
            </el-input>
          </base-input>
        </div>
      </div>
      <div class="enn__integration__list-wrapper mt-3 d-flex flex-column">
        <!-- <div class="p-2 rounded-2" :style="{background:this.$global.globalBoxBgColor}">
          hello
        </div> -->
        <div v-if="filteredIntegrations.length == 0" style="display: flex; justify-content: center; flex-direction: column; align-items: center;">
          <img src="/img/empty-box.png" alt="empty" style="max-height: 400px; max-width: 400px;" />
          <p style="text-align: center;">Data not found.</p>
        </div>
        <card v-for="(item, i) in filteredIntegrations" :key="item.slug" class="rounded-2 cursor-pointer col-12 mb-0">
          <div @click.stop="redirectToDetailsPage(item.slug)"
            class="'p-2 d-flex justify-content-between align-items-center'">

            <div class="d-flex align-items-center emm-integration-item justify-content-between w-100">
              <div class="w-75 d-flex align-items-center" style="gap:16px">
                <!-- <i v-if="item.slug == 'mailboxpower'" class="fa-regular fa-envelope-open" style="font-size: 1.6rem; color: #0091ff;"></i> -->
                <!-- <i v-else-if="item.slug == 'clickfunnels'" class="fas fa-mouse-pointer" style="font-size: 1.6rem; color: #0091ff;"></i> -->
                <img
                  v-if="getLogoSrc(item)"
                  :class="['logo-wrap', { 'logo-wrap--sendjim': item.slug === 'sendjim' }]"
                  :src="getLogoSrc(item)"
                  alt="brand-logo"
                />
                <i
                  v-else-if="getIconClass(item)"
                  :class="getIconClass(item)"
                  class="logo-wrap"
                  style="font-size: 1.6rem; color: #0091ff;"
                ></i>
                <p v-else></p>
                
                <div>
                  <h5 class="mb-0 integration-brand-name">{{ item.custom_name || item.name }}</h5>
                  <span class="brand-sub-heading">{{ item.custom_description || item.description }}</span>
                </div>
              </div>
              <div v-if="item.active"
                class="emm__integration-status-wrapper border rounded p-1 d-flex align-items-center">
                <span class="integration-status-indicator rounded-pill  bg-success d-block "></span>
                <span class="status-text">{{ item.active }} Active</span>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Button} from 'element-ui';
import { ErrorPage } from '../../components'

export default {
  components: {
    ErrorPage,
    [Button.name] : Button,
  },
  data() {
    return {
      searchQuery: '',
      selectedType: 'all',
      integrations: [
        {
          name: 'Twilio SendGrid',
          description: 'Deliver Exceptional Email Experiences with SendGrid',
          img: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/sendgrid-logo.png',
          type: 'Mail',
          slug: 'sendgrid'
        },
        {
          name: 'Lead Connector',
          description: 'Get Better Clicks & Engagement - Enhance Your Email Campaigns.',
          img: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/large-leadconnector.png',
          type: 'Communication',
          slug: 'gohighlevel'
        }, 
        {
          name: 'Kartra',
          description: 'Streamline your marketing with an all-in-one marketing platform',
          img: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/kartralogo.jpeg',
          type: 'Communication',
          slug: 'kartra'
        },
        {
          name: 'Zapier/Webhook',
          description: 'The easiest way to automate you work',
          img: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/webhooklink.png',
          type: 'Communication',
          slug: 'zapier'
        },
        {
          name: 'MailBox Power',
          description: 'Get Better Clicks & Engagement - Enhance Your Email Campaigns.',
          img: '',
          type: 'Communication',
          slug: 'mailboxpower'
        },
        {
          name: 'ClickFunnels',
          description: 'Build High-Converting Sales Funnels - Turn Visitors into Customers Easily.',
          img: '',
          type: 'Communication',
          slug: 'clickfunnels'
        },
        {
          name: 'Agency Zoom',
          description: 'The easiest way to automate you work',
          img: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/agencyzoom_logo.png',
          type: 'Communication',
          slug: 'agencyzoom'
        },
        {
          name: 'SendJim',
          description: 'Direct Mail Marketing.',
          img: 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/systems/sendjimlogo.webp',
          type: 'Communication',
          slug: 'sendjim'
        },
      ],
      integrationStatus: {
        loading: false,
        error: false,
      }
    }
  },
  methods: {
    redirectToDetailsPage(slug) {
      this.$router.push(`/integrations/${slug}`)
    },
    getCustomIntegrations(){
        this.integrationStatus.loading = true;
        this.integrationStatus.error = false;
        const userData = this.$store.getters.userData;
        const payload = {
            company_id: userData.company_parent,
        }

        this.$store.dispatch('getCustomIntegrations', payload).then(response => {
            // Get list of slugs from API response (these are the visible integrations)
            const visibleSlugs = response.data.map(integration => integration.slug);
            
            // Only merge integrations that exist in API response (not hidden)
            // Filter out integrations that are not in API response (hidden by backend)
            const merged = this.integrations
              .filter(item => visibleSlugs.includes(item.slug)) // Only keep integrations that are in API response
              .map(item => {
                const refData = response.data.find(integration => integration.slug === item.slug);
                if (refData) {
                  return {
                    ...item,
                    id: refData.id,
                    name: refData.name || item.name,
                    custom_name: refData.custom_name,
                    icon: refData.icon,
                    custom_icon: refData.custom_icon,
                    custom_slug: refData.custom_slug,
                    slug: refData.slug || item.slug,
                    custom_img: refData.custom_img,
                    custom_description: refData.custom_description,
                    refcode: refData.refcode,
                  };
                }
                return item;
              });

            this.integrations = merged;
            this.integrationStatus.loading = false;
          }).catch(error => {
            console.log(error);
            this.integrationStatus.loading = false;
            this.integrationStatus.error = true;
        })
    },
    getLogoSrc(item) {
      return item.custom_img || item.img || null;
    },
    getIconClass(item) {
      return item.custom_icon || item.icon || null;
    }
  },
  computed: {
   filteredIntegrations() {  
    const searchQuery = this.searchQuery.toLowerCase();
    return this.integrations.filter(integration => {
      const matchesType = this.selectedType === 'all' || integration.type === this.selectedType;
      const nameToSearch = (integration.custom_name || integration.name || '').toLowerCase();
      const description = (integration.custom_description || integration.description || '').toLowerCase();
      const matchesSearch = nameToSearch.includes(searchQuery) || description.includes(searchQuery);
      return matchesType && matchesSearch;
      
    })
      .sort((a, b) => {
        const nameA = (a.custom_name || a.name || '').toLowerCase();
        const nameB = (b.custom_name || b.name || '').toLowerCase();
        return nameA.localeCompare(nameB);
      });
   }
  },
  mounted() {
    this.getCustomIntegrations();
  },
  created() {
    const userType = this.$store.getters.userData.user_type;
    if (userType !== 'client') {
      this.$router.replace('/404'); // redirect ke halaman 404
    }
  }
};
</script>

<style lang="scss">
.integration-filters {
  gap: 16px;

  .filter-item-integration {
    cursor: pointer;
  }

  .emm__integration-serach-input-wrapper {
    flex: 1;

    .form-group {
      margin-bottom: 0 !important;
    }
  }
}

.enn__integration__list-wrapper {
  gap: 16px;
}

.emm-integration-item {
  gap: 16px;
  cursor: pointer;
}

.logo-wrap {
  height: 32px;
  width: auto;
  max-width: 32px;
  object-fit: cover;
  flex-shrink: 0;
}

.logo-wrap--sendjim {
  max-width: 80px; /* wider but still aligned */
}

.integration-brand-name {
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  font-style: normal;
}

.brand-sub-heading {
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  font-style: normal;
}

.emm__page-heading {
  font-size: 30px;
  font-weight: 600;
  line-height: 100%;
  font-style: normal;
}

.emm__page-sub-heading {
  font-size: 16px;
  font-weight: 400;
  line-height: 150%;
  font-style: normal;
}

.emm__integration-status-wrapper {
  gap: 8px;
  cursor: pointer;

  .status-text {
    font-size: 12px;
  }
}

.integration-status-indicator {
  height: 14px;
  width: 14px;
}

.input__integrations .el-input__inner {
  padding-left: 30px;
  padding-right: 30px;
}

.filter-item-integration {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.filter-item-integration:hover {
  background-color: var(--text-btn-black);
  color: black;
}

.filter-item-integration.active {
  background-color: var(--text-btn-black);
  color: black;
}

</style>